export var CameraType;

(function (CameraType) {
  CameraType["front"] = "front";
  CameraType["back"] = "back";
})(CameraType || (CameraType = {}));

export var ImageType;

(function (ImageType) {
  ImageType["png"] = "png";
  ImageType["jpg"] = "jpg";
})(ImageType || (ImageType = {}));